import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import UserIconNew from "../../../../../../gd-components/icons/user/user"
import {SortDirection} from "../../../../../../data-structures/sort"
import {AggregateFunctionType} from "../../../../../../data-structures/aggregators/types"

function renderUserIcons(userIds: ID[], iconsToShow: number): React.ReactElement[] {
    const users = _(userIds)
        .map((id: ID) => {
            return gd.session.users.get(id)
        })
        .orderBy(
            [(u: any) => {
                return u?.name?.toLowerCase() ?? ''
            }],
            [SortDirection.ASC]
        ).value()

    const result: React.ReactElement[] = []

    const userIcon = (id: ID) => (
        <div key        = {id}
             className  = "ico"
        >
            <UserIconNew
                className   = "user-icon"
                size        = "22"
                hint        = "up"
                userId      = {id}
            />
        </div>
    )

    if (users.length > iconsToShow) {
        const showCount = iconsToShow - 1
        users.slice(0, showCount).forEach((user: any) => {
            if (user) {
                result.push(userIcon(user.id))
            }
        })
        const more = users.length - showCount
        if (more > 0) {
            result.push(
                <div key="more" className="ico">
                    <div className="ui5-counter circle-user">+{more}</div>
                </div>
            )
        }
    } else {
        users.forEach((user: any) => {
            if (user) {
                result.push(userIcon(user.id))
            }
        })
    }

    return result
}

export default function FieldTimeReportUser_TableCellCalculated(props: FieldTableCellProps) {
    const { listItem, column } = props

    let iconsToShow = 5
    if (column.width) {
        iconsToShow = Math.ceil((column.width - 20) / 25)
    }

    const calculatedData = listItem.calculated.dataByAggregateFunction[props.field.fieldId]?.[AggregateFunctionType.USERS_UNION]

    let userIds: ID[]
    if (listItem.view.isCollapsed && calculatedData?.hasChildren) {
        userIds = calculatedData.total.userIds ?? []
    } else {
        userIds = calculatedData?.own ?? (listItem.item as any).reportedByUsersIds ?? []
    }

    const icons = renderUserIcons(userIds, iconsToShow)

    return (
        <div className  = {Classes("cell-flex is-hovered", props.className)}
             style      = {getTableCellStyle(props)}
        >
            <div className="ui5-field-editable size-small w-100-percent h-100-percent">
                <div className="ui5-users-group txt-truncate">{icons}</div>
            </div>
        </div>
    )
}
